export const APP_VERSION = '2.1.0';
export const BUILD_TIME = '2026-09-29T05:33:08.511Z';
export const BUILD_NUMBER = '20260929053308';
